import React from 'react';
import PropTypes from 'prop-types';

import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../../molecules/mixed-copy/mixedCopy';
import OutroStage from './outro.style';
import FullscreenMedia from '../../molecules/fullscreen-media/fullscreenMedia';

const Outro = ({
  video = '',
  teaserImage = '',
  headline = '',
  subline = '',
  copy = '',
  ...props
}) => (
  <OutroStage imageFormat={teaserImage ? teaserImage.imageFormat : null} {...props}>
    <Container className="outro__container">
      {video && (
        <FullscreenMedia
          alignment="right"
          customTheme="#D4EAF3"
          type="introVideo"
          hoster={video.hoster}
          videoId={video.videoId}
          previewImage={teaserImage}
        />
      )}

      {teaserImage && !video && (
        <FullscreenMedia
          type="fullwidthImage"
          alignment="right"
          customTheme="#D4EAF3"
          file={teaserImage}
        />
      )}

      {subline && (
        <Headline tag="h3" subline>
          {subline}
        </Headline>
      )}

      <Headline tag="h2" secondary>
        {headline}
      </Headline>

      {copy && <MixedCopy focused fullWidth html={copy} className="outro__introduction" />}
    </Container>
  </OutroStage>
);

Outro.propTypes = {
  headline: PropTypes.string,
  subline: PropTypes.string,
  copy: PropTypes.string,
  video: PropTypes.shape({
    type: PropTypes.string,
    hoster: PropTypes.string,
    videoId: PropTypes.string
  }),
  teaserImage: PropTypes.shape({
    src: PropTypes.string.isRequired,
    credits: PropTypes.string,
    imageFormat: PropTypes.oneOf(['portrait', 'landscape'])
  })
};

export default Outro;
